var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005BAA",
    d: "M8 1.5A6.5 6.5 0 1 0 14.5 8 6.507 6.507 0 0 0 8 1.5m-.25 3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m.75 7a1 1 0 0 1-1-1V8a.5.5 0 0 1 0-1 1 1 0 0 1 1 1v2.5a.5.5 0 0 1 0 1"
  })));
};
export default SvgInfoIcon;